import React, { useState, useEffect } from "react";
import DashboardWidget from "../../components/widget/DashboardWidget";
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { serverUrl } from "../../temp";

const SuperAdminDashboard = ({ token }) => {
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        if (token) {
            fetchSuperAdminData();
        }
    }, [token]);

    // Update time every second
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    // Format date and time
    const formattedDate = currentTime.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    const formattedDay = currentTime.toLocaleDateString('en-US', { weekday: 'long' });
    const formattedTime = currentTime.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });

    const fetchSuperAdminData = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${serverUrl}/super-admin/dashboard-cards`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch dashboard data");
            }

            const data = await response.json();
            setDashboardData(data.data);
        } catch (error) {
            console.error("Dashboard fetch error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="dashboard super-admin-dashboard">
            <h2 className="dashboard-title">Centers' Stats</h2>
            <div className="widgets">
                {loading ? (
                    <>
                        <DashboardWidget.Skeleton />
                        <DashboardWidget.Skeleton />
                        <DashboardWidget.Skeleton />
                        <DashboardWidget.Skeleton />
                    </>
                ) : (
                    <>
                        <DashboardWidget
                            title={dashboardData?.total_centers?.card_title || "Total Centers"}
                            value={dashboardData?.total_centers?.value ?? 0}
                            icon={<BusinessIcon className="icon super-admin-icon" />}
                        />

                        {dashboardData?.campus_wise_students?.campus_breakdown?.map((campus) => (
                            <DashboardWidget
                                key={campus.center_id}
                                title={`${campus.center_name}`}
                                value={campus.student_count ?? 0}
                                icon={<PeopleIcon className="icon super-admin-icon" />}
                            />
                        ))}

                        {/* Calculate how many placeholders we need */}
                        {Array.from({
                            length: Math.max(0, 3 - (dashboardData?.campus_wise_students?.campus_breakdown?.length || 0))
                        }).map((_, index) => (
                            <div key={`placeholder-${index}`} className="widget-placeholder" />
                        ))}
                    </>
                )}
            </div>
            {/* Date & Time Section */}
            <div className="datetime-section">
                <div className="datetime-card date-card">
                    <CalendarTodayIcon className="datetime-icon" />
                    <div className="datetime-content">
                        <div className="date">{formattedDate}</div>
                        <div className="day">{formattedDay}</div>
                    </div>
                </div>

                <div className="datetime-card time-card">
                    <AccessTimeIcon className="datetime-icon" />
                    <div className="time">{formattedTime}</div>
                </div>
            </div>
        </div>
    );
};

export default SuperAdminDashboard;